import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { AppConstant } from '@app/shared/constants';
import { LoginSignUpModel } from '@app/core/models/loginsignupmodel';
import { environment } from '@env/environment';
import {IUserLocalDetails} from '@app/core/services/localStorage/Ilocal-storage.interface';

@Injectable({
  providedIn: 'root'
})

export class LoginService {

  constructor(private http: HttpClient) {
  }

  /**Function to login */
  login(login: LoginSignUpModel) {
    return this.http.post(environment.baseUrl + AppConstant.LOGIN, login);
  }

  GetGAData(storeUrl: any) {
    return this.http.get(environment.baseUrl + AppConstant.GetGAInfo + storeUrl);
  }

  // end
  /**Function to send forgot password email */
  forgotPassword(email: string, redirectTo) {
    return this.http.get<any>(environment.baseUrl + AppConstant.FORGOT_PASSWORD + '?ForgetPasswordEmailId=' + `${email}`+'&redirectTo=' + redirectTo);
  }

  /**Function to send forgot password email */
  resetPassword(email: string,token: any, newPassword: any) {
    return this.http.get<any>(environment.baseUrl + AppConstant.RESET_PASSWORD + '?email=' + `${email}` + '&Token='
    + `${token}` + '&NewPassword=' + `${newPassword}`);
  }
  confrimEmail(email: string, token: any) {
    return this.http.get<any>(environment.baseUrl + AppConstant.EMAIL_CONFIRM + '?email=' + `${email}` + '&Token='
    + `${token}`);
  }
}
